import * as React from "react";
import { Text, View, Image, StyleSheet } from "react-native";

import { useNavigation, useRoute } from "@react-navigation/native";
import { useDispatch } from "react-redux";
import GlobalStyles from "../../components/GlobalStyles";
// import { Ionicons } from "@expo/vector-icons"; a part of cleaner code

import SignUp from "../../components/auth/SignUp";

export default function SignUpScreen() {
  //  const navigation = useNavigation(); a part of cleaner code
  const dispatch = useDispatch();

  const route = useRoute();
  const formMode = route.params.formMode;

  return (
    <View style={GlobalStyles.containerMB}>
      <View style={GlobalStyles.bodyContainerCards}>
        <View>
          {formMode === "" ? (
            <Text>Error - Signup Mode Unchosen</Text>
          ) : (
            <SignUp mode={formMode} />
          )}
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  // buttonStyle: {
  //   marginTop: 10,
  //   paddingTop: 15,
  //   paddingBottom: 15,
  //   backgroundColor: "#337599",
  //   borderRadius: 30,
  // } a part of cleaner code
});
